var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "22px",
    viewBox: "0 0 25 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Invite Pending") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System-Icons",
    transform: "translate(-189.000000, -554.000000)",
    stroke: "#999999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pending-Grey",
    transform: "translate(189.500000, 553.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "synchronize-arrow-clock",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5,20 C18.8847763,20 23.25,15.6347763 23.25,10.25 C23.25,4.86522369 18.8847763,0.5 13.5,0.5 C8.11522369,0.5 3.75,4.86522369 3.75,10.25 L3.75,11",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "0.75 7.997 3.75 10.997 6.75 7.997"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    points: "12.75 4.247 12.75 10.997 18 10.997"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.9109c34152f7674e8ff525b0c9ce5b95.svg";
export { ForwardRef as ReactComponent };